export const StoryEndpoints = {
  List: '/v3/stories',
  Detail: (id: string) => `/v3/stories/${id}`,
  Open: (id: string) => `/v3/stories/${id}/open`,
  Saved: (id: string) => `/v3/stories/${id}/saved`,
  Progress: (id: string) => `/v3/stories/${id}/progress`,
  Complete: (id: string) => `/v3/stories/${id}/complete`,
  Levels: '/v3/course/level'
} as const
